import React from 'react';
import { ChevronDownIcon, UsersIcon } from 'lucide-react';
import { salesManagers } from '../../data/salesManagers';
import type { TeamFilter } from '../CallsInsightHub/useCallsInsightHub';
interface TeamSelectProps {
  value: TeamFilter;
  onChange: (team: TeamFilter) => void;
}
export function TeamSelect({
  value,
  onChange
}: TeamSelectProps) {
  return <label className="relative inline-flex" data-id="element-148" data-mp="31baa53df3du4">
      <span className="sr-only" data-id="element-149" data-mp="3p2z5ksljcifa">Team</span>
      <UsersIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle" aria-hidden data-id="element-150" data-mp="3p14m7ipwwydb" />
      <select value={value} onChange={e => onChange(e.target.value as TeamFilter)} className="appearance-none rounded-xl border border-line bg-surface py-2 pl-9 pr-9 text-[13px] font-medium text-ink shadow-card transition-colors duration-150 ease-out hover:border-accent/30 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/15" data-id="element-151" data-mp="3f51iw9jbqtos">
        <option value="All" data-id="element-152" data-mp="28mmkywpjs4ba">All teams</option>
        {salesManagers.map(m => <option key={m.team} value={m.team} data-id="element-153" data-mp="1n8fnjqtzm0ap">
            {m.label}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle" aria-hidden data-id="element-154" data-mp="1j8x3ex9zpt8x" />
    </label>;
}